module.exports = {
  name: 'html', base: '_item', prototype: {
    element_selector: '.xp_html',

    val: function (value) {
      if (!arguments.length) {
        return this.disabled ? undefined : this.$element.html();
      } else {
        this.$element.html(value);

        this.change();

        return this;
      }
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/html.js
 ** module id = 21
 ** module chunks = 0
 **/